import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setSession } from "@/lib/api";
import { Factory, Lock, User } from "@phosphor-icons/react";
import logoPopCopos from "@/assets/login-pop-copos.jpg";

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      setSession(data.user);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Falha ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 h-screen overflow-hidden">
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-12 bg-white overflow-y-auto">
        <div className="flex items-center gap-3 mb-12">
          <Factory size={36} weight="bold" />
          <div>
            <div className="font-head font-black text-2xl leading-none">SISTEMA PRODUÇÃO</div>
            <div className="overline text-zinc-500 mt-1">Copos Personalizados · Bling ERP</div>
          </div>
        </div>

        <h1 className="font-head text-2xl sm:text-3xl font-black tracking-tight mb-3">
          Painel<br />de Controle
        </h1>
        <p className="text-zinc-600 mb-10 max-w-md">
          Entre com sua conta de administrador para acessar o sistema de produção e
          sincronização com o Bling.
        </p>

        <form onSubmit={handleSubmit} className="max-w-md space-y-5" data-testid="login-form">
          <div>
            <label className="label">Usuário</label>
            <div className="relative">
              <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                type="text"
                className="input pl-10"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="login-username"
                placeholder="Bem-vindo! Digite seu usuário"
                autoComplete="username"
              />
            </div>
          </div>
          <div>
            <label className="label">Senha</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
              <input
                type="password"
                className="input pl-10"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>
          </div>

          {error && (
            <div className="border border-[#E60000] bg-red-50 text-[#E60000] px-4 py-3 text-sm font-medium" data-testid="login-error">
              {error}
            </div>
          )}

          <button type="submit" className="btn w-full" disabled={loading} data-testid="login-submit">
            {loading ? "Entrando..." : "Entrar no Painel"}
          </button>
        </form>
      </div>

      <div className="hidden lg:block relative bg-black overflow-hidden">
        <img
          src={logoPopCopos}
          alt="POP COPOS — Personalizamos Momentos"
          className="w-full h-full object-cover object-center"
          data-testid="login-logo"
        />
      </div>
    </div>
  );
}
